export default "__VITE_ASSET__7dbbf86f__"